import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-auto mt-4 pa-2 access-text text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_ctx.breakpoint === 'xs' || _ctx.breakpoint === 'sm')
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "info",
            variant: "tonal",
            class: "mx-auto mb-4",
            "max-width": "400",
            density: "compact"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Use a larger screen for a better experience. This app is best viewed on a tablet or desktop. ")
            ])),
            _: 1,
            __: [2]
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card, {
        class: _normalizeClass(['mx-auto', 'pa-2', 'card', { 'mt-8': _ctx.breakpoint === 'xs' || _ctx.breakpoint === 'sm', 'mt-16': _ctx.breakpoint !== 'xs' && _ctx.breakpoint !== 'sm' }]),
        "max-width": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Sign in ")
                ])),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, { autofill: "on" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                name: "username",
                label: "Username",
                type: "text",
                placeholder: "username",
                required: "",
                rules: _ctx.usernameRules,
                variant: "outlined",
                class: "mx-2",
                id: "username"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                name: "password",
                label: "Password",
                type: "password",
                placeholder: "password",
                required: "",
                onKeyup: _withKeys(_ctx.signin, ["enter"]),
                rules: _ctx.passwordRules,
                variant: "outlined",
                class: "mx-2",
                id: "password"
              }, null, 8, ["modelValue", "onKeyup", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.signin,
                text: "Go",
                variant: "outlined",
                disabled: _ctx.signinDisabled()
              }, null, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/forgot-password",
          class: "d-block mb-2"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Forgot Password?")
          ])),
          _: 1,
          __: [4]
        }),
        _createVNode(_component_router_link, { to: "/register" }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Register here")
          ])),
          _: 1,
          __: [5]
        })
      ])
    ]),
    _: 1
  }))
}